import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
    baseURL: API_URL,
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('facit_authToken');
        if (token) {
            try {
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
            } catch (error) {
                // Handle potential JSON parsing error
                console.error('Error parsing user data', error);
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            console.log('Unauthorized');

            // Unauthorized - clear local storage and redirect to login
            localStorage.removeItem('facit_authUserData');
            localStorage.removeItem('facit_authToken');
            window.location.href = '/auth-pages/login';

        }
        return Promise.reject(error);
    }
);

export default api;